import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  StyledModal,
  StyledErrorLottie,
  StyledErrorPaper,
  CancelButton,
  DownloadButton,
  StyledARIcon,
} from "../styles/Mainpage-styled";

import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CancelIcon from "@material-ui/icons/Cancel";

import ARCoreIcon from "../../../assets/ar_icon_button/logo_ar_core.png";
import ChromeIcon from "../../../assets/ar_icon_button/logo_chrome.png";

const ErrorModal = ({ openError, handleErrorClose }) => {
  const { t, i18n } = useTranslation();

  const [lottie, setLottie] = useState("");

  useEffect(() => {
    const lottieLoader = async () => {
      if (i18n.language === "zh") {
        const lottieData = await import(
          "../../../assets/error_lottie/error_unsupport_mobile/zh/lennie_error_ae_viewer.json"
        );
        setLottie(lottieData.default);
      } else {
        const lottieData = await import(
          "../../../assets/error_lottie/error_unsupport_mobile/en/lennie_error_ae_viewer.json"
        );
        setLottie(lottieData.default);
      }
    };
    lottieLoader();
  }, [i18n.language]);

  return (
    <StyledModal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={openError}
      onClose={handleErrorClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
    >
      <Fade in={openError} timeout={0}>
        <StyledErrorPaper>
          <CancelButton onClick={handleErrorClose} aria-label="Cancel">
            <CancelIcon />
          </CancelButton>
          <StyledErrorLottie
            loop
            play
            animationData={lottie}
            rendererSettings={{ preserveAspectRatio: "xMidYMid slice" }}
          />
          <DownloadButton
            href="https://play.google.com/store/apps/details?id=com.android.chrome&hl=en"
            style={{ marginBottom: "3%" }}
          >
            {t("mainPage.button.errorModalChromeDownloadButton", "Download")}{" "}
            <StyledARIcon src={ChromeIcon} />
          </DownloadButton>
          <DownloadButton href="https://play.google.com/store/apps/details?id=com.google.ar.core&hl=en">
            {t("mainPage.button.errorModalArCoreDownloadButton", "Download")}{" "}
            <StyledARIcon src={ARCoreIcon} />
          </DownloadButton>
        </StyledErrorPaper>
      </Fade>
    </StyledModal>
  );
};

export default ErrorModal;
